import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { IOAuthCredential } from '../../types/OAuth/IOAuthCredential';

export interface IGetOAuthCredentialsResult extends IGetItemsResult {
  credentials: IOAuthCredential[];
}

export class GetOAuthCredentialsRequest extends Request<IGetItemsParams, IGetOAuthCredentialsResult> {
  constructor(params: IGetItemsParams) {
    super('getOAuthCredentials', params);
  }
}

export class GetValidOAuthCredentialsRequest extends Request<IGetItemsParams, IGetOAuthCredentialsResult> {
  constructor(params: IGetItemsParams) {
    super('getValidOAuthCredentials', params);
  }
}
